(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@dipscope/type-manager"));
	else if(typeof define === 'function' && define.amd)
		define("$DSEntityStore", ["@dipscope/type-manager"], factory);
	else if(typeof exports === 'object')
		exports["$DSEntityStore"] = factory(require("@dipscope/type-manager"));
	else
		root["$DSEntityStore"] = factory(root["$DSTypeManager"]);
})(this, (__WEBPACK_EXTERNAL_MODULE__7908__) => {
return 